'use client';

import { useLocale } from 'next-intl';

/**
 * Link textual que re-abre el modal CMP desde cualquier página. Útil en la
 * política de cookies y en el footer. Envía el evento global
 * `nqoro:openCmp` que <ConsentBanner> escucha.
 *
 * Label bilingüe: usa el locale activo para mostrar el texto correcto
 * cuando no se pasa explícitamente.
 */
export function ReopenCmpLink({ label }: { label?: string }) {
  const locale = useLocale();
  const resolved =
    label ?? (locale === 'en-US' ? 'manage your preferences' : 'gestiona tus preferencias');
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event('nqoro:openCmp'))}
      className="underline underline-offset-2 hover:text-[var(--color-accent)]"
    >
      {resolved}
    </button>
  );
}
